import { Text, Title } from "@clipboard-health/ui-react";
import { Alert, CircularProgress, Grid, Stack } from "@mui/material";
import { groupBy } from "lodash";

import { APP_V2_USER_EVENTS, useLogEffect } from "../lib/analytics";
import { useSupportArticles } from "./api/useSupportArticles";
import { ExternalHelpCenterLinkButton } from "./ExternalHelpCenterLinkButton";
import { SupportArticleGroup } from "./SupportArticleGroup";
import { SupportContactInfo } from "./SupportContactInfo";

export function HelpCenterPage() {
  const { data, isLoading, isError, isSuccess } = useSupportArticles();

  const groupedArticles = groupBy(data?.data ?? [], (item) => item.attributes.category);

  useLogEffect(APP_V2_USER_EVENTS.HELP_CENTER_PAGE_VIEWED);

  return (
    <Stack p={5} sx={{ backgroundColor: "inherit" }} spacing={5} height="100%">
      <Title component="h1">Help Center</Title>
      <SupportContactInfo />
      <ExternalHelpCenterLinkButton />
      {isLoading && <CircularProgress />}
      {isError && <Alert severity="error">Error loading support articles</Alert>}
      {isSuccess && data.data.length === 0 && <Text>No support articles</Text>}
      {isSuccess && data.data.length > 0 && (
        <Grid container rowGap={6} columns={{ md: 2, xl: 3 }} p={3}>
          {Object.keys(groupedArticles).map((group) => (
            <Grid key={group} item xs={1}>
              <SupportArticleGroup
                key={group}
                title={group}
                supportArticles={groupedArticles[group]}
              />
            </Grid>
          ))}
        </Grid>
      )}
    </Stack>
  );
}
